import {
  Box,
  DownloadButton,
  downloadCsv,
  Flex,
  Headings,
  Text,
  VerticalSpacer,
  WideBox,
} from '@foradevelopment/fora-ui';
import { swedishNumberFormatter } from '@fora-monorepo/string-utils';

import { useAppDispatch } from '../../redux/hooks';
import { getInvoiceCsv, getInvoiceFile } from '../../redux/invoice/invoiceThunks';
import { downloadInvoiceFile } from '../../redux/invoice/utils';
import { useTypedTranslation } from '../../i18n/i18n';

type InvoiceInfoBoxProps = {
  invoiceNumber: string;
  ocrNumber: string | undefined;
  amountLeftToPay: number;
  showCsvDownloadButton: boolean;
};

export const InvoiceInfoBox = ({
  invoiceNumber,
  ocrNumber,
  amountLeftToPay,
  showCsvDownloadButton,
}: InvoiceInfoBoxProps) => {
  const { t } = useTypedTranslation();
  const dispatch = useAppDispatch();

  const invoiceOrOcrNumber = ocrNumber ?? invoiceNumber;

  const downloadInvoiceDetailsCSV = async () => {
    const result = await dispatch(getInvoiceCsv({ invoiceNumber }));
    if (getInvoiceCsv.fulfilled.match(result)) {
      if (result?.payload?.base64EncodedFile) {
        downloadCsv(result.payload.base64EncodedFile, `Fora_Detaljerade_Kostnader_${invoiceOrOcrNumber}.csv`);
        return null;
      }
      return t('errorMessages.somethingWentWrongNoFileTryLater');
    } else {
      return t('errorMessages.somethingWentWrongWithCsvTryAgain');
    }
  };

  const downloadInvoicePDF = async () => {
    const result = await dispatch(getInvoiceFile({ invoiceNumber, ocrNumber }));
    if (getInvoiceFile.fulfilled.match(result)) {
      if (result?.payload?.base64EncodedFile) {
        downloadInvoiceFile(result.payload.base64EncodedFile, `Fora_FakturaFil_${invoiceOrOcrNumber}.pdf`);
        return null;
      }
      return t('errorMessages.somethingWentWrongNoFileTryLater');
    } else {
      return t('errorMessages.somethingWentWrongWithPdfTryAgain');
    }
  };

  return (
    <WideBox>
      <Flex justifyContent={'space-between'} flexDirection={['column', 'row', 'row']}>
        <Box>
          <DownloadButton
            name={`${t('section.invoiceDetails.pdfFile')} ${invoiceOrOcrNumber} (PDF)`}
            download={downloadInvoicePDF}
          />
          <VerticalSpacer marginBottom="10px" />
          {showCsvDownloadButton && (
            <DownloadButton
              name={`${t('section.invoiceDetails.csvFile')} ${invoiceOrOcrNumber} (CSV)`}
              download={downloadInvoiceDetailsCSV}
            />
          )}
        </Box>
        <Box textAlign={['left', 'right', 'right']} marginTop={[20, 0, 0]}>
          <Text color="black70">
            {amountLeftToPay >= 0 ? t('section.invoiceDetails.payAmount') : t('section.invoiceDetails.isCredited')}
          </Text>
          <Headings.H2>{swedishNumberFormatter(amountLeftToPay)} kr</Headings.H2>
        </Box>
      </Flex>
    </WideBox>
  );
};
